var styles = {
  "AxisTitle": "_AxisTitle_ahut2_1"
};

export { styles as default };
